import config from '../config/Config';

export const getBlobUrl = (key: string): string => `${config.cdn_host}/${config.s3_bucket_root}/${key}`;
